import { requestApi } from '../util/network'

// qa列表 type 有  account、order、pay、shipping、refund、service、security
// 分别对应        账户相关、订单管理、支付方式、配送与发货、退换货政策、客服服务、隐私与安全
export const getAboutContent =
  (type) =>
    requestApi(
      '/about/getAboutContent',
      'POST',
      {
        type: type,
        lang: JSON.parse(localStorage.getItem('lang')) || 'en'
      },
      'member'
    )

// qa列表
export const getQA =
  (type) =>
    requestApi(
      '/about/getQA',
      'POST',
      {
        type: type
      },
      'member'
    )

// 富文本之类
export const getAbout =
  (type) =>
    requestApi(
      '/about/getContent',
      'POST',
      {
        type: type
      },
      'member'
    )

// 系统文章
export const getDocumentInfo =
  (type) =>
    requestApi(
      '/Document/agreement',
      'GET',
      {
        type: type
      }
    )

// 获取文章分类
export const getArticleclassList =
  () =>
    requestApi(
      '/Articleclass/index',
      'GET',
      {
      }
    )

// 获取文章列表
export const getArticleList =
  (params, acId) =>
    requestApi(
      '/Article/article_list',
      'GET',
      {
        'ac_id': acId,
        'page': params.page // 当前第几页
      }
    )

// 获取文章详情
export const getArticleDetail =
  (articleID) =>
    requestApi(
      '/Article/article_show',
      'GET',
      {
        'article_id': articleID
      }
    )
